import {
  LOADED_AUTHCONFIG,
  USER_LOADING,
  USER_LOADED,
  USER_PROFILE_UPDATING,
  USER_PROFILE_UPDATED,
  USER_PROFILE_UPDATE_FAIL,
  AUTH_ERROR,
  LOGIN_UPDATING,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_UPDATING,
  LOGOUT_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
} from '../actions/types'

const initialState = {
  token: window.localStorage.getItem('token') || null,
  isAuthenticated: null,
  isLoading: false,
  isUdating: false,
  user: null,
  OAuthDetails: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOADED_AUTHCONFIG:
      return {
        ...state,
        ...action.payload,
      }
    case USER_LOADING:
      return {
        ...state,
        isLoading: true,
      }
    case USER_PROFILE_UPDATING:
    case LOGOUT_UPDATING:
    case LOGIN_UPDATING:
      return {
        ...state,
        isUdating: true,
      }
    case USER_PROFILE_UPDATED:
    case USER_PROFILE_UPDATE_FAIL:
      return {
        ...state,
        isAuthenticated: true,
        isUdating: false,
        ...action.payload,
      }
    case USER_LOADED:
    case LOGIN_SUCCESS:
      if (action.payload.user) {
        window.localStorage.setItem('token', action.payload.token)
        window.localStorage.setItem('user_id', action.payload.user._id)
      }
      return {
        ...state,
        ...action.payload,
        isAuthenticated: typeof action.payload.user?._id != 'undefined',
        isLoading: false,
        isUdating: false,
      }
    case REGISTER_SUCCESS:
      // window.localStorage.setItem('token', action.payload.token);
      return {
        ...state,
        ...action.payload,
        // isAuthenticated: false,
        isUdating: false,
      }
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT_SUCCESS:
    case REGISTER_FAIL:
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('user_id')
      return {
        ...state,
        token: null,
        user: null,
        OAuthDetails: null,
        isAuthenticated: null,
        isLoading: false,
        isUdating: false,
      }
    default:
      return state
  }
}
